<template>
  <div class="d-none d-xl-block">
    <b-button
      v-if="showArrowButton"
      v-b-tooltip.hover
      :disabled="disableScrollTopButton"
      variant="none"
      :class="['arrow-button']"
      :style="arrowButtonStyle"
      :title="lang != 'ENG' ? '위로 가기' : 'Go to top'"
      @click="scrollToTop"
    >
      <div class="icon-container" :style="iconContainerStyle">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 21.4111L12.0001 5.38076" stroke="white" stroke-width="2.5" />
          <path d="M11.1152 3.44143L20.0568 12.3829" stroke="white" stroke-width="2.5" />
          <path d="M12.8849 3.44143L3.94337 12.3829" stroke="white" stroke-width="2.5" />
        </svg>
      </div>
    </b-button>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ArrowButton',
  props: {
    disableScrollTopButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showArrowButton: false
    };
  },
  computed: {
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('report_list', ['lang']),
    ...mapGetters(['is_viewer']),
    arrowButtonStyle() {
      return {
        position: 'fixed',
        bottom: this.is_viewer ? '13.5px' : '80px',
        right: '7.2px',
        zIndex: '1070',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: this.is_viewer ? this.selected_report.main_color : '#33a2a9',
        padding: '0 10px'
      };
    },
    iconContainerStyle() {
      const baseStyle = {
        background: 'linear-gradient(45deg, #008895, #007695)',
        borderRadius: '100px',
        boxShadow: 'rgba(149, 157, 165, 0.5) 0px 0px',
        transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
        border: '1.4px solid  #33a2a9'
      };
      if (this.is_viewer) {
        baseStyle.background = this.selected_report.main_color;
        baseStyle.border = `1.4px solid ${this.selected_report.main_color}`;
      }
      return baseStyle;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll() {
      this.showArrowButton = window.scrollY > 100;
    }
  }
};
</script>

<style scoped>
.arrow-button:disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

.arrow-button:hover:not(:disabled) {
  color: black;
}

.icon-container:hover {
  box-shadow: rgba(149, 157, 165, 0.55) 0px 8px 16px;
}

.icon-container svg {
  width: 32px;
  height: 32px;
  fill: white;
}

/* --- [수정된 부분 2] --- */
.icon-container {
  padding: 25px;
}
@media (max-width: 768px) {
  .icon-container {
    padding: 12px;
  }
}
</style>
